// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"ef370f26","457":"ff4107a4","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};